import React from "react";

import EcoIcon from "../eco-icon/EcoIcon";

type EcoPaginationProps = {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
  disabled?: boolean;
};

/** Janela de até 5 números de página em volta da atual. */
const pageWindow = (current: number, totalPages: number) => {
  const start = Math.max(1, Math.min(current - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

/** "Mostrando 1 a 10 de 46" + anterior / números / próxima. Some com uma página só. */
const EcoPagination: React.FC<EcoPaginationProps> = ({ page, pageSize, total, onChange, disabled }) => {
  if (total <= pageSize) return null;

  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);

  return (
    <nav className="ecoPager" aria-label="Paginação">
      <span className="ecoPager__info">
        Mostrando {first} a {last} de {total}
      </span>
      <div className="ecoPager__buttons">
        <button
          type="button"
          className="ecoBtn ecoBtn--sm ecoPager__btn"
          onClick={() => onChange(Math.max(1, page - 1))}
          disabled={disabled || page <= 1}
          aria-label="Página anterior"
        >
          <EcoIcon name="chevronLeft" size={18} />
        </button>
        {pageWindow(page, totalPages).map((n) => (
          <button
            key={n}
            type="button"
            className={`ecoBtn ecoBtn--sm ecoPager__btn${n === page ? " is-current" : ""}`}
            onClick={() => onChange(n)}
            aria-current={n === page ? "page" : undefined}
            disabled={disabled}
          >
            {n}
          </button>
        ))}
        <button
          type="button"
          className="ecoBtn ecoBtn--sm ecoPager__btn"
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          disabled={disabled || page >= totalPages}
          aria-label="Próxima página"
        >
          <EcoIcon name="chevronRight" size={18} />
        </button>
      </div>
    </nav>
  );
};

export default EcoPagination;
